export const WORLDS = [
  { key: "MOUNTAINS", num: "01", name: "Mountains", image: "/dawn/kilimanjaro-summit.jpg", blurb: "Journeys into high-altitude landscapes, remote terrain, mountain communities and the world's high places." },
  { key: "RIVERS", num: "02", name: "Rivers", image: "/expeditions/rafting.jpg", blurb: "Journeys shaped by rivers, from mountain waterways and whitewater to the landscapes and communities connected to them." },
  { key: "OCEANS", num: "03", name: "Oceans", image: "/expeditions/ocean.jpg", blurb: "Journeys along coastlines, islands and marine environments, exploring the relationship between ocean, wildlife and people." },
  { key: "LAND", num: "04", name: "Land", image: "/dawn/vor-trek.jpg", blurb: "Expeditions across forests, deserts, grasslands, rural landscapes and remote territories." },
  { key: "WILDLIFE", num: "05", name: "Wildlife", image: "/expeditions/wildlife.jpg", blurb: "Field journeys into wildlife landscapes to observe, photograph and document species, habitats and the relationship between wildlife and people." },
];

export const EXPEDITION_STATUS = {
  CONCEPT: { label: "Concept", cls: "bg-ptf-primary/10 text-ptf-primary" },
  RESEARCH: { label: "Research", cls: "bg-ptf-primary/10 text-ptf-primary" },
  PLANNING: { label: "Planning", cls: "bg-amber-500/20 text-amber-800" },
  UPCOMING: { label: "Upcoming · Applications open", cls: "bg-emerald-700 text-emerald-50" },
  "IN THE FIELD": { label: "In the Field", cls: "bg-ptf-accent text-ptf-primary" },
  DOCUMENTATION: { label: "Documentation", cls: "bg-sky-900 text-sky-100" },
  COMPLETED: { label: "Completed", cls: "bg-ptf-primary/70 text-ptf-bg" },
  "FILM RELEASED": { label: "Film Released", cls: "bg-sky-900 text-sky-100" },
  "FESTIVAL CIRCUIT": { label: "Festival Circuit", cls: "bg-sky-900 text-sky-100" },
  ARCHIVE: { label: "Archive", cls: "bg-ptf-primary/15 text-ptf-primary" },
};

export const EXPEDITION_TYPES = ["EXPEDITION", "ADVENTURE EXPEDITION", "WILDLIFE EXPEDITION", "DOCUMENTARY EXPEDITION", "PHOTOGRAPHY EXPEDITION", "FILM EXPEDITION", "FIELD JOURNEY", "COMMUNITY JOURNEY"];

export const OUTPUT_OPTIONS = ["FILM", "DOCUMENTARY", "PHOTOGRAPHY", "FIELD JOURNAL", "STORY"];

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const YEAR_OPTIONS = [["", "Any Year"], ["2026", "2026"], ["2027", "2027"], ["2028", "2028"], ["FUTURE", "Future"]];

export const STATUS_FILTERS = [
  ["", "All"],
  ["UPCOMING", "Upcoming"],
  ["APPLICATIONS_OPEN", "Applications Open"],
  ["IN_DEVELOPMENT", "In Development"],
  ["COMPLETED", "Completed"],
  ["IN_THE_FIELD", "In The Field"],
  ["DOCUMENTATION", "Documentation"],
];

export const journeyTerrains = (j) => (j.terrains?.length ? j.terrains : j.world ? [j.world] : []);

export function journeyMonths(j) {
  if (!j.start_date) return [];
  const s = new Date(j.start_date);
  if (isNaN(s)) return [];
  const e = j.end_date ? new Date(j.end_date) : s;
  const out = [];
  let y = s.getFullYear();
  let m = s.getMonth();
  const ey = isNaN(e) ? y : e.getFullYear();
  const em = isNaN(e) ? m : e.getMonth();
  while (y < ey || (y === ey && m <= em)) {
    out.push({ year: y, month: m + 1 });
    m += 1;
    if (m > 11) { m = 0; y += 1; }
    if (out.length > 36) break;
  }
  return out;
}

export function matchesStatus(j, key) {
  const es = j.expedition_status || "";
  switch (key) {
    case "UPCOMING": return es === "UPCOMING";
    case "APPLICATIONS_OPEN": return es === "UPCOMING" && ["OPEN", "UPCOMING"].includes(j.status);
    case "IN_DEVELOPMENT": return ["CONCEPT", "RESEARCH", "PLANNING"].includes(es);
    case "COMPLETED": return ["COMPLETED", "ARCHIVE", "FILM RELEASED", "FESTIVAL CIRCUIT"].includes(es);
    case "IN_THE_FIELD": return es === "IN THE FIELD";
    case "DOCUMENTATION": return es === "DOCUMENTATION";
    default: return true;
  }
}

export const FILM_STATUS = {
  IDEA: "Idea", "PRE-PRODUCTION": "Pre-production", "FIELD PRODUCTION": "Field production",
  "POST-PRODUCTION": "Post-production", "FESTIVAL SUBMISSIONS": "Festival submissions",
  SCREENINGS: "Screenings", RELEASED: "Released", ARCHIVED: "Archived",
};

export const FESTIVAL_STATUSES = ["SUBMITTED", "UNDER CONSIDERATION", "SELECTED", "SCREENED", "AWARDED", "NOT SELECTED"];

export const APPLICANT_ROLES = ["PARTICIPANT", "PHOTOGRAPHER", "FILMMAKER", "WRITER", "RESEARCHER", "NATURALIST", "FIELD ASSISTANT"];

export const PIPELINE = ["Expedition", "Field Production", "Editing", "Documentary / Film", "Festival Submissions", "Screenings", "Digital / Educational Release"];

export const FUTURE_CATEGORIES = ["Himalayan Expeditions", "River Expeditions", "Ocean Expeditions", "Wildlife Expeditions", "African Expeditions", "Desert Expeditions", "Forest Expeditions", "Community Journeys", "Polar / Extreme Environment Expeditions"];

export const EXPEDITIONS_FAQ = [
  { q: "What is a Planet Trotter expedition?", a: "A field journey with a defined mission: to experience a landscape, meet its people, observe its wildlife and document what is found. The journey is the beginning; the documentation becomes the story, and the story can become a film, photography project or field journal." },
  { q: "Can I join a Planet Trotter expedition?", a: "Expeditions marked Upcoming accept applications. Each expedition defines who it is for, and applications are reviewed by the expedition team; participation is curated, not sold as a package." },
  { q: "Does Planet Trotter make documentary films?", a: "Yes. Films grow out of expeditions: Dawn: A Project of Belief, The Last Horizon and High Altitude: A Valley's Flag are currently in pre-production. Films may be submitted to appropriate film festivals in India and internationally, subject to editorial completion, eligibility and festival selection." },
  { q: "What types of expeditions does Planet Trotter organise?", a: "Journeys across five field environments: mountains, rivers, oceans, land and wildlife, in India and around the world. Each expedition page states its type, status, mission and outputs; nothing is presented as confirmed unless it is." },
  { q: "How can I participate as a photographer or filmmaker?", a: "The expedition application form lets you apply as a photographer, filmmaker, writer, researcher, naturalist or field assistant, with your portfolio, equipment and proposed contribution." },
];
